// extracted by mini-css-extract-plugin
module.exports = {"navigationMenu":"useMobileNavigation_navigationMenu__pHV2X","placeholderShimmer":"useMobileNavigation_placeholderShimmer__38TtP"};